import {computedFn} from '@api'
import {TLBounds, TLShape, Utils} from '@tldraw/core'

/**
 * Find the bounds of a rectangular shape.
 * @param shape
 */
export const getBoundsRectangle = computedFn((shape: TLShape & { size: number[] }) => {
  const [width, height] = shape?.size ?? [0, 0],
    bounds = {
      minX: 0,
      maxX: width,
      minY: 0,
      maxY: height,
      width,
      height
    }

  return Utils.translateBounds(bounds, shape?.point ?? [0,0])
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/shared/getBoundsRectangle.ts